<div class="category-tree">
  @if (showCategories()) {
    @for (category of currentCategories; track $index) {
      <div class="category-tree__parent">
        <app-category-tree-child
          [params]="params"
          [category]="category"
          [useNavigate]="useNavigate">
        </app-category-tree-child>
        @if (category.children.length > 0) {
          <span [attr.data-test]="'button-toggleCategory-' + category.name"
              class="category-tree__hide"
              [ngClass]="visibleCategories.includes(category.name) ? 'icon-arrow-up-large': 'icon-arrow-down'"
              (click)="toggleCategory(category)">
          </span>
        }
        @for (cat of category.children; track $index) {
          <ul class="category-tree__children" [ngClass]="{'hidden': !visibleCategories.includes(category.name)}">
            <li>
              <app-category-tree-child
                  [params]="params"
                  [category]="cat"
                  [useNavigate]="useNavigate">
              </app-category-tree-child>
              <ul class="category-tree__children nested">
                @for (child of cat.children; track $index) {
                  <li>
                    <app-category-tree-child
                        [params]="params"
                        [category]="child"
                        [useNavigate]="useNavigate">
                    </app-category-tree-child>
                    <ul class="category-tree__children nested">
                      @for (child of child.children; track $index) {
                        <li>
                          <app-category-tree-child
                              [params]="params"
                              [category]="child"
                              [useNavigate]="useNavigate">
                          </app-category-tree-child>
                        </li>
                      }
                    </ul>
                  </li>
                }
              </ul>
            </li>
          </ul>
        }
      </div>
    }
  }
  @if (showCategoriesLoader()) {
    <span class="stripe stripe-short toplevel"></span>
    <ul class="category-tree__children">
      <li class="category-tree__title main">
        <span class="stripe stripe-half"></span>
        <ul class="category-tree__children nested">
          <li class="stripe stripe-long"></li>
          <li class="stripe stripe-long"></li>
          <li class="stripe stripe-long"></li>
        </ul>
      </li>
    </ul>
  }
</div>
